<ion-list-header> {{ userInfo.firstName }} {{ userInfo.lastName }} </ion-list-header>
<ion-note>{{ userInfo.email }}</ion-note>
